import { connectorPlatformLabel } from '@/entities/media-connector';

export interface ScopeLabelInput {
  platforms: ReadonlyArray<string>;
  /** The campaign the view is scoped to, already resolved to a name. */
  campaignScope?: string;
}

/**
 * Names every narrowing the exported figures were actually computed under, not just the
 * platform filter. The deck's title is built from this string, so a campaign-scoped export
 * that omitted the campaign would hand a client one campaign's spend under a heading that
 * claims the whole project - or, with a platform filter also on, the whole platform.
 * Undefined only when nothing narrows the view and the project name alone is the truth.
 */
export function scopeLabelFrom({ platforms, campaignScope }: ScopeLabelInput): string | undefined {
  const parts = campaignScope ? [campaignScope] : [];
  if (platforms.length > 0) {
    parts.push(platforms.map(connectorPlatformLabel).join(', '));
  }
  return parts.length > 0 ? parts.join(' - ') : undefined;
}
